import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import * as yup from 'yup';

import API from '@/apiRequest';
import UpdateAllowedAtDateComponent from '@/components/UpdateAllowedAtDate/UpdateAllowedAtDateComponent';
import { showToast } from '@/store/ducks/toasts';

const UpdateAllowedAtDateContainer = ({ orderId, closeModal, refreshHandler }) => {
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const intl = useIntl();

  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        allowed_at_date: yup
          .string()
          .required(intl.formatMessage({ id: 'REQUIRED_FIELD' }))
          .matches(
            /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4} (?:[01][0-9]|2[0-3]):[0-5][0-9]$/,
            intl.formatMessage({ id: 'invalidDateTimeFormat' })
          ),
      }),
    [intl]
  );

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await API.patch(`orders/${orderId}/allowed-at-date`, {
        allowed_at_date: values.allowed_at_date,
      });
      refreshHandler();
      dispatch(
        showToast({
          type: 'success',
          title: intl.formatMessage({ id: 'SUCCESS' }),
          text: intl.formatMessage({
            id: 'DATE_UPDATED_SUCCESS',
          }),
          duration: 5000,
        })
      );
      closeModal();
    } catch (err) {
      console.log(err?.response || err);
      setError(
        err?.response?.status === 500 || !err?.response?.data?.message
          ? intl.formatMessage({ id: 'UNKNOWN_ERROR' })
          : intl.formatMessage({ id: err.response.data.message })
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <UpdateAllowedAtDateComponent
      error={error}
      validationSchema={validationSchema}
      handleSubmit={handleSubmit}
      intl={intl}
    />
  );
};

UpdateAllowedAtDateContainer.propTypes = {
  orderId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  refreshHandler: PropTypes.func.isRequired,
};

export default UpdateAllowedAtDateContainer;
